import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const ErrorMessage = ({ message }) => {
  const classes = useStyles()
  return <Typography className={classes.message}>{message ? message : ''}</Typography>
}

export default ErrorMessage

const useStyles = makeStyles({
  message: {
    fontSize: '12px',
    color: '#f44336',
    marginLeft: '4px'
  }
})
